import { Component, DestroyRef, inject, input, OnInit, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-search-bar',
  standalone: true,
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.css',
})
export class SearchBarComponent implements OnInit {
  public placeholder = input<string>('Buscar...');
  public debounceTime = input<number>(300);

  public search = output<string>();

  private searchSubject = new Subject<string>();
  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.searchSubject.pipe(
      debounceTime(this.debounceTime()),
      distinctUntilChanged(),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(value => {
      this.search.emit(value);
    });
  }

  public onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.searchSubject.next(value);
  }
}
